import { Constant } from "utils/enums";
import { FirebaseAuthBackend, getFirebaseBackend } from "../../../helpers/firebase_helper";

// action
import { RegisterDTO } from "./dto/register.dto";
import { registerUserFailed, registerUserSuccessful, resetRegisterFlagChange } from "./reducer";
import { createBusiness, getBusinessBySellerId, postSignUp } from "helpers/backend_helper";
import { postLogin, postUserDetails } from "helpers/fakebackend_helper";
import { Media } from "reactstrap";
import { businessBySellerId } from "live-slices/business/thunk";
import { getAuthMe } from "live-slices/thunk";
import { toast } from "react-toastify";

let signupDTO: RegisterDTO;

export const initializeRegisterFlow = () => {
  signupDTO = new RegisterDTO();
}

export const getSignupDTO = () => {
  return signupDTO;
}

export const savePhoneNumber = (phoneNumber: string) => {
  signupDTO.phoneNumber = phoneNumber;
}

export const sendFirebaseOTP = async (isResend: boolean = false) => {
  const fireBaseBackend: FirebaseAuthBackend | null = getFirebaseBackend();
  if (signupDTO && signupDTO.phoneNumber) {
    const res = await fireBaseBackend?.sendOTPCode(signupDTO.phoneNumber,isResend);
    return true;
  } else {
    return false;
  }
}

export const signUp = (user: any,history:any) => async (dispatch: any) => {
  try {
    const response: any = await postSignUp(
      {
        email: user.email,
        password: user.password,
        fullName: user.fullName,
        phoneNumber: user.phoneNumber,
        verificationId :user.verificationId 
      }
    );
    
    if (response.success) {
      dispatch( loginUserRegister({
        userName: user.email,
        password: user.password,
      },history)) 
      // history('/login')
      // dispatch(registerUserSuccessful({data:"data"}));
     } else {
      toast.error(response.message || "Error occurred during signup.", {
        autoClose: 1000,
      });
    }
  } catch (error: any) {
    console.error("Signup API Error:", error);
    toast.error(
      error.message || "Your OTP has expired. Please request a new one.",
      { autoClose: 1000 }
    );
    dispatch(registerUserFailed(error));
  }
};

export const loginUserRegister = (user: any, history: any) => async (dispatch: any) => {
  try {
    let response = postLogin({
        userName: user.userName,
        password: user.password,
      });
    

    var data:any = await response;

    if (data) {
      localStorage.setItem(
        Constant.access_token,
        JSON.stringify(data.access_token)
      );
      localStorage.setItem(
        Constant.refresh_token,
        JSON.stringify(data.refresh_token)
      );
      let userD: any = await postUserDetails();
      if (userD) {
        // if (!data.isStoreCreated) {
        //   await createBusiness({
        //     "accountType": "normal",
        //     "sellerType": "",
        //     "storeName": userD.email,
        //     "email": userD.email 
        //   })
        // }
        let userMain = JSON.stringify(userD)
        localStorage.setItem(
          Constant.user,
          userMain
        );
        history('/set-seller-store');
        dispatch(registerUserSuccessful(JSON.parse(userMain)));





      }
    }
  } catch (error: any) {
    dispatch(registerUserFailed(error));
  }
};

const convertTimingToISOString = (day: string, time: string): string => {
  const today = new Date();
  const dayOffset = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'].indexOf(day.toLowerCase());
  const currentDay = today.getDay();
  today.setDate(today.getDate() + (dayOffset - currentDay));
  const [hours, minutes] = time.split(':').map(Number);
  today.setHours(hours, minutes, 0, 0);

  return today.toISOString();
};


export const CreateBusiness =
  (business: any, history: any) => async (dispatch: any) => {
    try {
      const formattedTimings = business.timings.map((timing: any) => ({
        day: timing.day,
        slotsTiming: timing.isOpen
          ? timing.slotsTiming.map((slot: any) => ({
              startTime: slot.startTime,
              endTime: slot.endTime,
            }))
          : [],
        isOpen: timing.isOpen,
      }));
      let response: any = await createBusiness({ 
        accountType: business.accountType,
        storeName: business.storeName,
        timings: formattedTimings,
        email: business.email,
        shopLogo: business.shopLogo
      });
      if(response && response.isSuccess){
        let userMain = JSON.stringify(response.data);
        localStorage.setItem(Constant.seller, userMain);

        dispatch(businessBySellerId(response.data.sellerId));
        dispatch(getAuthMe());

        history("/on-boarding");
      } else {
        toast.error(response.message, { autoClose: 1000 });
      }
    } catch (error: any) {
      dispatch(registerUserFailed(error));
    }
  };


export const verifyFirebaseOTP = async (code: any) => {
  var global = window as any;
  global.confirmationResult.confirm(code).then((result: any) => {
    const user = result.user;
    
  }).catch((error: any) => {
    // User couldn't sign in (bad verification code?)
    // ...
  });
}


// Is user register successfull then direct plot user in redux.
export const registerUser = (user: any) => async (dispatch: any) => {
};

export const resetRegisterFlag = () => {
  try {
    const response = resetRegisterFlagChange();
    return response;
  } catch (error) {
    return error;
  }
};

// export const apiError = () => {
//   try {
//     const response = apiErrorChange();
//     return response;
//   } catch (error) {
//     return error;
//   }
// };